'use client';

import styled from './SearchBlock.module.scss';
import { IconStop } from "@/public/assets/icons/IconStop";
import { IconSettings } from "@/public/assets/icons/IconSettings";
import { Popover } from "@/shared/ui/Popover";
import { useSearchBlock } from "../../hooks/useSearchBlock";
import { SearchBlockProps } from './types';
import { useEffect, useMemo, useState, useTransition } from 'react';
import { LinearProgress } from '@mui/material';
import { searchStore } from '@/shared/store/searchStore/searchStore';
import { usePathname, useRouter } from 'next/navigation';
import { authStore } from '@/shared/store/authStore/authStore';
import { wsSearch } from '@/shared/service/wsSearch/wsSearch';
import { Tooltip } from '@/shared/ui/Tooltip';

export function SearchBlock({ id, name, mnn, getActiveSessions, handleSetPathname, isLast, isActive , isFirst }: SearchBlockProps) {
  const [isPending, setTransition] = useTransition();
  const {    
    anchorEl,
    handleCanceledSession,
    count, 
  } = useSearchBlock({ id, getActiveSessions, isActive });

  const [idDisabledWS, setIdDisabledWS] = useState(wsSearch.isConnected());
  
  useEffect(() => {
    const unsubscribe = wsSearch.subscribe((connected) => {
      setIdDisabledWS(connected);
    });
    return () => unsubscribe();
  }, []);

  const isAdmin = useMemo(() => authStore.state.userInfo && authStore.state.userInfo.roleId === 1, [authStore.state.userInfo]);
  const router = useRouter();
  const fullPathname = usePathname();

  const handleChangePathname = (uid: number) => {
    setTransition(() => {
      searchStore.sync.setActiveSession(Number(uid));
      handleSetPathname(uid);
    });
  };

  async function handleSetPathnameByPopover(pathnamePopover: string) {
    if (pathnamePopover === fullPathname) return;

    setTransition(() => {
      router.push(`${pathnamePopover}?id=${id}`);
    });
  }

  async function handleSetPathnameByPopoverArchive(pathnamePopover: string) {
    if (pathnamePopover === fullPathname) return;

    setTransition(() => {
      router.push(`${pathnamePopover}`);
    });
  }
  return (
    <>
      {isActive ? (
        <div className={styled.accordion_body_container_active} key={id} style={{ borderBottomLeftRadius: isLast ? '8px' : '0', borderBottomRightRadius: isLast ? '8px' : '0', borderTopLeftRadius: isFirst ? '8px' : '0px',  borderTopRightRadius: isFirst ? '8px' : '0px' }}>
          <div className={styled.accordion_body_container_group}>
            {isPending ? (<LinearProgress style={{ background: 'white', width: '180px' }}/>) : (
              <>
                <div className={styled.accordion_body_container_buttons}>
                  <button className={styled.accordion_body_container_stop}>
                    <IconStop/>
                  </button>
                </div>
                <button className={styled.accordion_body_container_text} onClick={() => {
                  if(!idDisabledWS)handleChangePathname(id);
                }} style={{
                  width: '137px',
                  paddingLeft: '0',
                  color: 'var(--unique-white-10)',
                }}>
                  {name}
                </button>
              </>
            )}
          </div>
          <button className={styled.accordion_body_container_settings} onClick={(e) => anchorEl.handleOpenPopover(e, id)} type="button">
            <IconSettings isHover={false}/>
          </button>
        </div>

      ) : (
        <div className={styled.accordion_body_notActive} key={id}>
          {isPending ? (<LinearProgress style={{ width: '180px', marginLeft: '8px' }}/>) : (
            <Tooltip title={idDisabledWS ? id === searchStore.state.webSocketSessions ? 'Сессия с активным поиском!' : 'Переключение не возможно, происходит активный поиск' : ''} placement="right">
              <button className={styled.accordion_body_container_text} type="button" onClick={() => {
                if(!idDisabledWS) { 
                  handleChangePathname(id);
                }else{
                  if(id === searchStore.state.webSocketSessions){
                    handleChangePathname(id);
                  }
                }
              }
              }>
                {name}

              </button>
            </Tooltip>
          )}
          <button className={styled.accordion_body_container_settings} onClick={(e) => anchorEl.handleOpenPopover(e, id)} type="button">
            <IconSettings fill="var(--gray-40)"/>
          </button>
        </div>
      )}
      <Popover
        open={Boolean(anchorEl.anchorEl)}
        anchorEl={anchorEl.anchorEl}
        onClose={anchorEl.handleClosePopover}
        padding="0px"
      >
        <div className={styled.popover}>
          {isAdmin && <button type="button" onClick={handleCanceledSession}>Отменить сессию</button>}
          {isAdmin && <button type="button" onClick={() => {
            anchorEl.handleClosePopover();
            handleSetPathnameByPopoverArchive(`/sessions?mnn=${mnn.replaceAll('+', "%2B")}`);
          }}>Архив сессии</button>}
          <button type="button" onClick={() => {
            anchorEl.handleClosePopover();
            handleSetPathnameByPopover('/basket');
          }}>Корзина <span>{count}</span></button>
        </div>
      </Popover>
    </>
  );
}
